// This file is auto-generated by @hey-api/openapi-ts

import {
    createClient,
    createConfig,
    type Options,
    type Client,
    formDataBodySerializer,
} from "@hey-api/client-fetch";
import type {
    PutApiUserUserConsentData,
    PutApiUserUserConsentError,
    PutApiUserUserConsentResponse,
    PutApiUserPreferencesUserSelectedDatabasesData,
    PutApiUserPreferencesUserSelectedDatabasesError,
    PutApiUserPreferencesUserSelectedDatabasesResponse,
    PutApiUserPreferencesModelData,
    PutApiUserPreferencesModelError,
    PutApiUserPreferencesModelResponse,
    PutApiUserPreferencesUseDocumentEngineData,
    PutApiUserPreferencesUseDocumentEngineError,
    PutApiUserPreferencesUseDocumentEngineResponse,
    GetApiUserUserDataError,
    GetApiUserUserDataResponse,
    PostApiUserLoginCallbackError,
    PostApiUserLoginCallbackResponse,
    PostApiExtractionsByExtractionIdMappingsData,
    PostApiExtractionsByExtractionIdMappingsError,
    PostApiExtractionsByExtractionIdMappingsResponse,
    PostApiExtractionsByExtractionIdData,
    PostApiExtractionsByExtractionIdError,
    PostApiExtractionsByExtractionIdResponse,
    PostApiExtractionsByExtractionIdTableData,
    PostApiExtractionsByExtractionIdTableError,
    PostApiExtractionsByExtractionIdTableResponse,
    GetApiExtractionsByExtractionIdData,
    GetApiExtractionsByExtractionIdError,
    GetApiExtractionsByExtractionIdResponse,
    GetApiExtractionsByExtractionIdStandardizedData,
    GetApiExtractionsByExtractionIdStandardizedError,
    GetApiExtractionsByExtractionIdStandardizedResponse,
    PutApiExtractionsByExtractionIdExtractionTypeData,
    PutApiExtractionsByExtractionIdExtractionTypeError,
    PutApiExtractionsByExtractionIdExtractionTypeResponse,
    GetApiExtractionsByExtractionIdExtractionTypeData,
    GetApiExtractionsByExtractionIdExtractionTypeError,
    GetApiExtractionsByExtractionIdExtractionTypeResponse,
    PostApiExtractionsByExtractionIdOutliersData,
    PostApiExtractionsByExtractionIdOutliersError,
    PostApiExtractionsByExtractionIdOutliersResponse,
    PostApiExtractionsByExtractionIdLlmDiagnosesDismissData,
    PostApiExtractionsByExtractionIdLlmDiagnosesDismissError,
    PostApiExtractionsByExtractionIdLlmDiagnosesDismissResponse,
    DeleteApiExtractionsDiscardData,
    DeleteApiExtractionsDiscardError,
    DeleteApiExtractionsDiscardResponse,
    GetApiExtractionsByExtractionIdExportSummarisedData,
    GetApiExtractionsByExtractionIdExportSummarisedError,
    GetApiExtractionsByExtractionIdExportSummarisedResponse,
    GetApiExtractionsExportSummarisedZipData,
    GetApiExtractionsExportSummarisedZipError,
    GetApiExtractionsExportSummarisedZipResponse,
    GetApiExtractionsByFileIdExportOriginalData,
    GetApiExtractionsByFileIdExportOriginalError,
    GetApiExtractionsByFileIdExportOriginalResponse,
    GetApiExtractionsExportOriginalZipData,
    GetApiExtractionsExportOriginalZipError,
    GetApiExtractionsExportOriginalZipResponse,
    GetApiExtractionsByExtractionIdValidationsData,
    GetApiExtractionsByExtractionIdValidationsError,
    GetApiExtractionsByExtractionIdValidationsResponse,
    GetApiExtractionsByExtractionIdLabelsetData,
    GetApiExtractionsByExtractionIdLabelsetError,
    GetApiExtractionsByExtractionIdLabelsetResponse,
    PostApiExtractionsByExtractionIdLabelsetData,
    PostApiExtractionsByExtractionIdLabelsetError,
    PostApiExtractionsByExtractionIdLabelsetResponse,
    PutApiExtractionsByExtractionIdRowTypeData,
    PutApiExtractionsByExtractionIdRowTypeError,
    PutApiExtractionsByExtractionIdRowTypeResponse,
    PutApiExtractionsByExtractionIdRowSignData,
    PutApiExtractionsByExtractionIdRowSignError,
    PutApiExtractionsByExtractionIdRowSignResponse,
    PutApiExtractionsByExtractionIdDocumentTargetRowData,
    PutApiExtractionsByExtractionIdDocumentTargetRowError,
    PutApiExtractionsByExtractionIdDocumentTargetRowResponse,
    PutApiExtractionsByExtractionIdCellValuesData,
    PutApiExtractionsByExtractionIdCellValuesError,
    PutApiExtractionsByExtractionIdCellValuesResponse,
    PutApiExtractionsByExtractionIdCellValuesRevertData,
    PutApiExtractionsByExtractionIdCellValuesRevertError,
    PutApiExtractionsByExtractionIdCellValuesRevertResponse,
    PutApiExtractionsByExtractionIdResetRowChangesData,
    PutApiExtractionsByExtractionIdResetRowChangesError,
    PutApiExtractionsByExtractionIdResetRowChangesResponse,
    PutApiExtractionsByExtractionIdColumnStateData,
    PutApiExtractionsByExtractionIdColumnStateError,
    PutApiExtractionsByExtractionIdColumnStateResponse,
    GetApiAnalyticsByFilterTypeData,
    GetApiAnalyticsByFilterTypeError,
    GetApiAnalyticsByFilterTypeResponse,
    GetApiCoaError,
    GetApiCoaResponse,
    GetApiCoaAccountsByCoaIdData,
    GetApiCoaAccountsByCoaIdError,
    GetApiCoaAccountsByCoaIdResponse,
    PostApiCoaAccountsMappingsByCoaIdData,
    PostApiCoaAccountsMappingsByCoaIdError,
    PostApiCoaAccountsMappingsByCoaIdResponse,
    PostApiCoaAccountsPermissionsData,
    PostApiCoaAccountsPermissionsError,
    PostApiCoaAccountsPermissionsResponse,
    DeleteApiCoaAccountsPermissionsData,
    DeleteApiCoaAccountsPermissionsError,
    DeleteApiCoaAccountsPermissionsResponse,
    PostApiCoaDraftCoaData,
    PostApiCoaDraftCoaError,
    PostApiCoaDraftCoaResponse,
    PutApiCoaDraftCoaByCoaIdData,
    PutApiCoaDraftCoaByCoaIdError,
    PutApiCoaDraftCoaByCoaIdResponse,
    DeleteApiCoaDraftCoaByCoaIdData,
    DeleteApiCoaDraftCoaByCoaIdError,
    DeleteApiCoaDraftCoaByCoaIdResponse,
    GetApiCoaAuditLogsByCoaIdData,
    GetApiCoaAuditLogsByCoaIdError,
    GetApiCoaAuditLogsByCoaIdResponse,
    GetApiCoaCoaDefinitionByCoaIdData,
    GetApiCoaCoaDefinitionByCoaIdError,
    GetApiCoaCoaDefinitionByCoaIdResponse,
    PostApiCoaDraftCoaAccountsByCoaIdData,
    PostApiCoaDraftCoaAccountsByCoaIdError,
    PostApiCoaDraftCoaAccountsByCoaIdResponse,
    PostApiCoaCompleteCoaByCoaIdData,
    PostApiCoaCompleteCoaByCoaIdError,
    PostApiCoaCompleteCoaByCoaIdResponse,
    PostApiCoaFilesData,
    PostApiCoaFilesError,
    PostApiCoaFilesResponse,
    GetApiCoaMappingTableByCoaIdData,
    GetApiCoaMappingTableByCoaIdError,
    GetApiCoaMappingTableByCoaIdResponse,
    GetApiInitialConfigError,
    GetApiInitialConfigResponse,
    GetApiThirdpartyAuth0ConfigError,
    GetApiThirdpartyAuth0ConfigResponse,
    GetApiProjectsData,
    GetApiProjectsError,
    GetApiProjectsResponse,
    PostApiProjectsData,
    PostApiProjectsError,
    PostApiProjectsResponse,
    GetApiProjectsWithPropertiesData,
    GetApiProjectsWithPropertiesError,
    GetApiProjectsWithPropertiesResponse,
    GetApiProjectsByProjectIdPropertyData,
    GetApiProjectsByProjectIdPropertyError,
    GetApiProjectsByProjectIdPropertyResponse,
    GetApiProjectsByProjectIdRentRollLocationData,
    GetApiProjectsByProjectIdRentRollLocationError,
    GetApiProjectsByProjectIdRentRollLocationResponse,
    PostApiProjectsPropertyNameExistsData,
    PostApiProjectsPropertyNameExistsError,
    PostApiProjectsPropertyNameExistsResponse,
    PostApiProjectsPropertyExistsData,
    PostApiProjectsPropertyExistsError,
    PostApiProjectsPropertyExistsResponse,
    PostApiProjectsProjectNameExistsData,
    PostApiProjectsProjectNameExistsError,
    PostApiProjectsProjectNameExistsResponse,
    PostApiProjectsByProjectIdFilesUploadData,
    PostApiProjectsByProjectIdFilesUploadError,
    PostApiProjectsByProjectIdFilesUploadResponse,
    PostApiProjectsByProjectIdFilesByFileIdExtractRentRollData,
    PostApiProjectsByProjectIdFilesByFileIdExtractRentRollError,
    PostApiProjectsByProjectIdFilesByFileIdExtractRentRollResponse,
    GetApiProjectsByProjectIdFilesData,
    GetApiProjectsByProjectIdFilesError,
    GetApiProjectsByProjectIdFilesResponse,
    DeleteApiProjectsByProjectIdFilesData,
    DeleteApiProjectsByProjectIdFilesError,
    DeleteApiProjectsByProjectIdFilesResponse,
    DeleteApiProjectsByProjectIdData,
    DeleteApiProjectsByProjectIdError,
    DeleteApiProjectsByProjectIdResponse,
    GetApiProjectsByProjectIdData,
    GetApiProjectsByProjectIdError,
    GetApiProjectsByProjectIdResponse,
    GetApiProjectsByProjectIdByAnnualizationTypeOperatingStatementPeriodsData,
    GetApiProjectsByProjectIdByAnnualizationTypeOperatingStatementPeriodsError,
    GetApiProjectsByProjectIdByAnnualizationTypeOperatingStatementPeriodsResponse,
    GetApiProjectsByProjectIdOperatingStatementData,
    GetApiProjectsByProjectIdOperatingStatementError,
    GetApiProjectsByProjectIdOperatingStatementResponse,
    GetApiProjectsByProjectIdExtractionByExtractionIdOverlappingPeriodsData,
    GetApiProjectsByProjectIdExtractionByExtractionIdOverlappingPeriodsError,
    GetApiProjectsByProjectIdExtractionByExtractionIdOverlappingPeriodsResponse,
    GetApiProjectsByProjectIdExtractionByExtractionIdConflictedExtractionsData,
    GetApiProjectsByProjectIdExtractionByExtractionIdConflictedExtractionsError,
    GetApiProjectsByProjectIdExtractionByExtractionIdConflictedExtractionsResponse,
    PostApiProjectsByProjectIdExtractionByExtractionIdConvertToDraftData,
    PostApiProjectsByProjectIdExtractionByExtractionIdConvertToDraftError,
    PostApiProjectsByProjectIdExtractionByExtractionIdConvertToDraftResponse,
    GetApiProjectsByProjectIdOperatingStatementExportData,
    GetApiProjectsByProjectIdOperatingStatementExportError,
    GetApiProjectsByProjectIdOperatingStatementExportResponse,
    PutApiProjectsUpdateData,
    PutApiProjectsUpdateError,
    PutApiProjectsUpdateResponse,
    PostApiProjectsPropertyCreateData,
    PostApiProjectsPropertyCreateError,
    PostApiProjectsPropertyCreateResponse,
    PutApiProjectsPropertyUpdateData,
    PutApiProjectsPropertyUpdateError,
    PutApiProjectsPropertyUpdateResponse,
    GetApiProjectsByDealByDealIdData,
    GetApiProjectsByDealByDealIdError,
    GetApiProjectsByDealByDealIdResponse,
    DeleteApiProjectsPropertyByPropertyIdData,
    DeleteApiProjectsPropertyByPropertyIdError,
    DeleteApiProjectsPropertyByPropertyIdResponse,
    GetApiProjectsPropertyInfoForDeleteByPropertyIdData,
    GetApiProjectsPropertyInfoForDeleteByPropertyIdError,
    GetApiProjectsPropertyInfoForDeleteByPropertyIdResponse,
    GetApiGoogleMapsConfigError,
    GetApiGoogleMapsConfigResponse,
    PostApiDatabasesScheduledDatabaseSyncError,
    PostApiDatabasesScheduledDatabaseSyncResponse,
    PostApiDatabasesManualDatabaseSyncError,
    PostApiDatabasesManualDatabaseSyncResponse,
    GetApiDatabasesByDatabaseIdCoaDefinitionsData,
    GetApiDatabasesByDatabaseIdCoaDefinitionsError,
    GetApiDatabasesByDatabaseIdCoaDefinitionsResponse,
    PostApiDatabasesAdminCoaDefinitionsData,
    PostApiDatabasesAdminCoaDefinitionsError,
    PostApiDatabasesAdminCoaDefinitionsResponse,
    GetApiDatabasesAdminAllError,
    GetApiDatabasesAdminAllResponse,
    GetApiDatabasesAdminCompaniesError,
    GetApiDatabasesAdminCompaniesResponse,
    PostApiDatabasesMetaData,
    PostApiDatabasesMetaError,
    PostApiDatabasesMetaResponse,
    PostApiDatabasesCompaniesByCompanyIdDatabasesData,
    PostApiDatabasesCompaniesByCompanyIdDatabasesError,
    PostApiDatabasesCompaniesByCompanyIdDatabasesResponse,
    DeleteApiDatabasesCompaniesByCompanyIdDatabasesByDatabaseIdData,
    DeleteApiDatabasesCompaniesByCompanyIdDatabasesByDatabaseIdError,
    DeleteApiDatabasesCompaniesByCompanyIdDatabasesByDatabaseIdResponse,
    PostApiDatabasesAdminCleanupE2eDatabasesData,
    PostApiDatabasesAdminCleanupE2eDatabasesError,
    PostApiDatabasesAdminCleanupE2eDatabasesResponse,
    GetThirdpartyV1DatabasesError,
    GetThirdpartyV1DatabasesResponse,
    GetThirdpartyV1DealsData,
    GetThirdpartyV1DealsError,
    GetThirdpartyV1DealsResponse,
    GetThirdpartyV1DealsByDealIdOperatingStatementData,
    GetThirdpartyV1DealsByDealIdOperatingStatementError,
    GetThirdpartyV1DealsByDealIdOperatingStatementResponse,
    GetThirdpartyV1DealsIdByDealIdOperatingStatementData,
    GetThirdpartyV1DealsIdByDealIdOperatingStatementError,
    GetThirdpartyV1DealsIdByDealIdOperatingStatementResponse,
    GetThirdpartyV1DealsByDealIdPeriodsData,
    GetThirdpartyV1DealsByDealIdPeriodsError,
    GetThirdpartyV1DealsByDealIdPeriodsResponse,
    GetThirdpartyV1DealsNameByDealNameOperatingStatementData,
    GetThirdpartyV1DealsNameByDealNameOperatingStatementError,
    GetThirdpartyV1DealsNameByDealNameOperatingStatementResponse,
    GetThirdpartyV1ProjectsData,
    GetThirdpartyV1ProjectsError,
    GetThirdpartyV1ProjectsResponse,
    GetThirdpartyV1ProjectsByProjectIdOperatingStatementData,
    GetThirdpartyV1ProjectsByProjectIdOperatingStatementError,
    GetThirdpartyV1ProjectsByProjectIdOperatingStatementResponse,
    GetThirdpartyV1ProjectsNameByProjectNameOperatingStatementData,
    GetThirdpartyV1ProjectsNameByProjectNameOperatingStatementError,
    GetThirdpartyV1ProjectsNameByProjectNameOperatingStatementResponse,
    GetThirdpartyV1ProjectsByProjectIdPeriodsData,
    GetThirdpartyV1ProjectsByProjectIdPeriodsError,
    GetThirdpartyV1ProjectsByProjectIdPeriodsResponse,
    GetThirdpartyV1ChartOfAccountsData,
    GetThirdpartyV1ChartOfAccountsError,
    GetThirdpartyV1ChartOfAccountsResponse,
    GetThirdpartyV1ChartOfAccountsByCoaIdData,
    GetThirdpartyV1ChartOfAccountsByCoaIdError,
    GetThirdpartyV1ChartOfAccountsByCoaIdResponse,
    GetHealthcheckError,
    GetHealthcheckResponse,
} from "./types.gen";

export const client: Client = createClient(createConfig());

/**
 * Set User Consent
 */
export const putApiUserUserConsent = <ThrowOnError extends boolean = false>(
    options: Options<PutApiUserUserConsentData, ThrowOnError>,
) => {
    return (options?.client ?? client).put<
        ThrowOnError,
        PutApiUserUserConsentResponse,
        PutApiUserUserConsentError
    >({
        ...options,
        url: "/api/user/user-consent",
    });
};

/**
 * Set User Preferences
 */
export const putApiUserPreferencesUserSelectedDatabases = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        PutApiUserPreferencesUserSelectedDatabasesData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).put<
        ThrowOnError,
        PutApiUserPreferencesUserSelectedDatabasesResponse,
        PutApiUserPreferencesUserSelectedDatabasesError
    >({
        ...options,
        url: "/api/user/preferences/user-selected-databases",
    });
};

/**
 * Set User Model
 */
export const putApiUserPreferencesModel = <
    ThrowOnError extends boolean = false,
>(
    options: Options<PutApiUserPreferencesModelData, ThrowOnError>,
) => {
    return (options?.client ?? client).put<
        ThrowOnError,
        PutApiUserPreferencesModelResponse,
        PutApiUserPreferencesModelError
    >({
        ...options,
        url: "/api/user/preferences/model",
    });
};

/**
 * Set Use Document Engine
 */
export const putApiUserPreferencesUseDocumentEngine = <
    ThrowOnError extends boolean = false,
>(
    options: Options<PutApiUserPreferencesUseDocumentEngineData, ThrowOnError>,
) => {
    return (options?.client ?? client).put<
        ThrowOnError,
        PutApiUserPreferencesUseDocumentEngineResponse,
        PutApiUserPreferencesUseDocumentEngineError
    >({
        ...options,
        url: "/api/user/preferences/use-document-engine",
    });
};

/**
 * Get User Data
 */
export const getApiUserUserData = <ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiUserUserDataResponse,
        GetApiUserUserDataError
    >({
        ...options,
        url: "/api/user/user-data",
    });
};

/**
 * Login Callback
 */
export const postApiUserLoginCallback = <ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiUserLoginCallbackResponse,
        PostApiUserLoginCallbackError
    >({
        ...options,
        url: "/api/user/login-callback",
    });
};

/**
 * Save Mappings
 */
export const postApiExtractionsByExtractionIdMappings = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        PostApiExtractionsByExtractionIdMappingsData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiExtractionsByExtractionIdMappingsResponse,
        PostApiExtractionsByExtractionIdMappingsError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/mappings",
    });
};

/**
 * Update Extraction
 */
export const postApiExtractionsByExtractionId = <
    ThrowOnError extends boolean = false,
>(
    options: Options<PostApiExtractionsByExtractionIdData, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiExtractionsByExtractionIdResponse,
        PostApiExtractionsByExtractionIdError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/",
    });
};

/**
 * Change Extraction Table
 */
export const postApiExtractionsByExtractionIdTable = <
    ThrowOnError extends boolean = false,
>(
    options: Options<PostApiExtractionsByExtractionIdTableData, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiExtractionsByExtractionIdTableResponse,
        PostApiExtractionsByExtractionIdTableError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/table",
    });
};

/**
 * Get Extraction
 */
export const getApiExtractionsByExtractionId = <
    ThrowOnError extends boolean = false,
>(
    options: Options<GetApiExtractionsByExtractionIdData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiExtractionsByExtractionIdResponse,
        GetApiExtractionsByExtractionIdError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}",
    });
};

/**
 * Get Standardized Extraction
 */
export const getApiExtractionsByExtractionIdStandardized = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        GetApiExtractionsByExtractionIdStandardizedData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiExtractionsByExtractionIdStandardizedResponse,
        GetApiExtractionsByExtractionIdStandardizedError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/standardized",
    });
};

/**
 * Update Extraction Type
 */
export const putApiExtractionsByExtractionIdExtractionType = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        PutApiExtractionsByExtractionIdExtractionTypeData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).put<
        ThrowOnError,
        PutApiExtractionsByExtractionIdExtractionTypeResponse,
        PutApiExtractionsByExtractionIdExtractionTypeError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/extraction-type",
    });
};

/**
 * Get Extraction Type
 */
export const getApiExtractionsByExtractionIdExtractionType = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        GetApiExtractionsByExtractionIdExtractionTypeData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiExtractionsByExtractionIdExtractionTypeResponse,
        GetApiExtractionsByExtractionIdExtractionTypeError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/extraction-type",
    });
};

/**
 * Dismiss Outliers
 */
export const postApiExtractionsByExtractionIdOutliers = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        PostApiExtractionsByExtractionIdOutliersData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiExtractionsByExtractionIdOutliersResponse,
        PostApiExtractionsByExtractionIdOutliersError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/outliers",
    });
};

/**
 * Dismiss Llm Diagnoses
 */
export const postApiExtractionsByExtractionIdLlmDiagnosesDismiss = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        PostApiExtractionsByExtractionIdLlmDiagnosesDismissData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiExtractionsByExtractionIdLlmDiagnosesDismissResponse,
        PostApiExtractionsByExtractionIdLlmDiagnosesDismissError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/llm-diagnoses/dismiss",
    });
};

/**
 * Discard Extractions
 */
export const deleteApiExtractionsDiscard = <
    ThrowOnError extends boolean = false,
>(
    options: Options<DeleteApiExtractionsDiscardData, ThrowOnError>,
) => {
    return (options?.client ?? client).delete<
        ThrowOnError,
        DeleteApiExtractionsDiscardResponse,
        DeleteApiExtractionsDiscardError
    >({
        ...options,
        url: "/api/extractions/discard",
    });
};

/**
 * Download Summarised
 */
export const getApiExtractionsByExtractionIdExportSummarised = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        GetApiExtractionsByExtractionIdExportSummarisedData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiExtractionsByExtractionIdExportSummarisedResponse,
        GetApiExtractionsByExtractionIdExportSummarisedError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/export/summarised",
    });
};

/**
 * Download Summarised Zip
 */
export const getApiExtractionsExportSummarisedZip = <
    ThrowOnError extends boolean = false,
>(
    options: Options<GetApiExtractionsExportSummarisedZipData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiExtractionsExportSummarisedZipResponse,
        GetApiExtractionsExportSummarisedZipError
    >({
        ...options,
        url: "/api/extractions/export/summarised/zip",
    });
};

/**
 * Download Original File
 */
export const getApiExtractionsByFileIdExportOriginal = <
    ThrowOnError extends boolean = false,
>(
    options: Options<GetApiExtractionsByFileIdExportOriginalData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiExtractionsByFileIdExportOriginalResponse,
        GetApiExtractionsByFileIdExportOriginalError
    >({
        ...options,
        url: "/api/extractions/{file_id}/export/original",
    });
};

/**
 * Download Original Files Zip
 */
export const getApiExtractionsExportOriginalZip = <
    ThrowOnError extends boolean = false,
>(
    options: Options<GetApiExtractionsExportOriginalZipData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiExtractionsExportOriginalZipResponse,
        GetApiExtractionsExportOriginalZipError
    >({
        ...options,
        url: "/api/extractions/export/original/zip",
    });
};

/**
 * Get Validations
 */
export const getApiExtractionsByExtractionIdValidations = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        GetApiExtractionsByExtractionIdValidationsData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiExtractionsByExtractionIdValidationsResponse,
        GetApiExtractionsByExtractionIdValidationsError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/validations",
    });
};

/**
 * Get Labelsets
 */
export const getApiExtractionsByExtractionIdLabelset = <
    ThrowOnError extends boolean = false,
>(
    options: Options<GetApiExtractionsByExtractionIdLabelsetData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiExtractionsByExtractionIdLabelsetResponse,
        GetApiExtractionsByExtractionIdLabelsetError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/labelset",
    });
};

/**
 * Update Labelset
 */
export const postApiExtractionsByExtractionIdLabelset = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        PostApiExtractionsByExtractionIdLabelsetData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiExtractionsByExtractionIdLabelsetResponse,
        PostApiExtractionsByExtractionIdLabelsetError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/labelset",
    });
};

/**
 * Update Row Type
 */
export const putApiExtractionsByExtractionIdRowType = <
    ThrowOnError extends boolean = false,
>(
    options: Options<PutApiExtractionsByExtractionIdRowTypeData, ThrowOnError>,
) => {
    return (options?.client ?? client).put<
        ThrowOnError,
        PutApiExtractionsByExtractionIdRowTypeResponse,
        PutApiExtractionsByExtractionIdRowTypeError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/row_type",
    });
};

/**
 * Flip Row Sign
 */
export const putApiExtractionsByExtractionIdRowSign = <
    ThrowOnError extends boolean = false,
>(
    options: Options<PutApiExtractionsByExtractionIdRowSignData, ThrowOnError>,
) => {
    return (options?.client ?? client).put<
        ThrowOnError,
        PutApiExtractionsByExtractionIdRowSignResponse,
        PutApiExtractionsByExtractionIdRowSignError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/row_sign",
    });
};

/**
 * Set Document Target Row
 */
export const putApiExtractionsByExtractionIdDocumentTargetRow = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        PutApiExtractionsByExtractionIdDocumentTargetRowData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).put<
        ThrowOnError,
        PutApiExtractionsByExtractionIdDocumentTargetRowResponse,
        PutApiExtractionsByExtractionIdDocumentTargetRowError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/document-target-row",
    });
};

/**
 * Edit Cell Values
 */
export const putApiExtractionsByExtractionIdCellValues = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        PutApiExtractionsByExtractionIdCellValuesData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).put<
        ThrowOnError,
        PutApiExtractionsByExtractionIdCellValuesResponse,
        PutApiExtractionsByExtractionIdCellValuesError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/cell-values",
    });
};

/**
 * Revert Cell Values
 */
export const putApiExtractionsByExtractionIdCellValuesRevert = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        PutApiExtractionsByExtractionIdCellValuesRevertData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).put<
        ThrowOnError,
        PutApiExtractionsByExtractionIdCellValuesRevertResponse,
        PutApiExtractionsByExtractionIdCellValuesRevertError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/cell-values/revert",
    });
};

/**
 * Reset Row Changes
 */
export const putApiExtractionsByExtractionIdResetRowChanges = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        PutApiExtractionsByExtractionIdResetRowChangesData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).put<
        ThrowOnError,
        PutApiExtractionsByExtractionIdResetRowChangesResponse,
        PutApiExtractionsByExtractionIdResetRowChangesError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/reset-row-changes",
    });
};

/**
 * Update Column State
 */
export const putApiExtractionsByExtractionIdColumnState = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        PutApiExtractionsByExtractionIdColumnStateData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).put<
        ThrowOnError,
        PutApiExtractionsByExtractionIdColumnStateResponse,
        PutApiExtractionsByExtractionIdColumnStateError
    >({
        ...options,
        url: "/api/extractions/{extraction_id}/column-state",
    });
};

/**
 * Get Analytics
 */
export const getApiAnalyticsByFilterType = <
    ThrowOnError extends boolean = false,
>(
    options: Options<GetApiAnalyticsByFilterTypeData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiAnalyticsByFilterTypeResponse,
        GetApiAnalyticsByFilterTypeError
    >({
        ...options,
        url: "/api/analytics/{filter_type}",
    });
};

/**
 * Get All Coa
 */
export const getApiCoa = <ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiCoaResponse,
        GetApiCoaError
    >({
        ...options,
        url: "/api/coa/",
    });
};

/**
 * Get Accounts By Coa Id
 */
export const getApiCoaAccountsByCoaId = <ThrowOnError extends boolean = false>(
    options: Options<GetApiCoaAccountsByCoaIdData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiCoaAccountsByCoaIdResponse,
        GetApiCoaAccountsByCoaIdError
    >({
        ...options,
        url: "/api/coa/accounts/{coa_id}",
    });
};

/**
 * Save Altered Custom Accounts
 */
export const postApiCoaAccountsMappingsByCoaId = <
    ThrowOnError extends boolean = false,
>(
    options: Options<PostApiCoaAccountsMappingsByCoaIdData, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiCoaAccountsMappingsByCoaIdResponse,
        PostApiCoaAccountsMappingsByCoaIdError
    >({
        ...options,
        url: "/api/coa/accounts-mappings/{coa_id}",
    });
};

/**
 * Grant Accounts Permissions
 */
export const postApiCoaAccountsPermissions = <
    ThrowOnError extends boolean = false,
>(
    options: Options<PostApiCoaAccountsPermissionsData, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiCoaAccountsPermissionsResponse,
        PostApiCoaAccountsPermissionsError
    >({
        ...options,
        url: "/api/coa/accounts-permissions",
    });
};

/**
 * Revoke Accounts Permissions
 */
export const deleteApiCoaAccountsPermissions = <
    ThrowOnError extends boolean = false,
>(
    options: Options<DeleteApiCoaAccountsPermissionsData, ThrowOnError>,
) => {
    return (options?.client ?? client).delete<
        ThrowOnError,
        DeleteApiCoaAccountsPermissionsResponse,
        DeleteApiCoaAccountsPermissionsError
    >({
        ...options,
        url: "/api/coa/accounts-permissions",
    });
};

/**
 * Create Draft Coa
 */
export const postApiCoaDraftCoa = <ThrowOnError extends boolean = false>(
    options: Options<PostApiCoaDraftCoaData, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiCoaDraftCoaResponse,
        PostApiCoaDraftCoaError
    >({
        ...options,
        url: "/api/coa/draft-coa",
    });
};

/**
 * Update Draft Coa
 */
export const putApiCoaDraftCoaByCoaId = <ThrowOnError extends boolean = false>(
    options: Options<PutApiCoaDraftCoaByCoaIdData, ThrowOnError>,
) => {
    return (options?.client ?? client).put<
        ThrowOnError,
        PutApiCoaDraftCoaByCoaIdResponse,
        PutApiCoaDraftCoaByCoaIdError
    >({
        ...options,
        url: "/api/coa/draft-coa/{coa_id}",
    });
};

/**
 * Delete Draft Coa
 */
export const deleteApiCoaDraftCoaByCoaId = <
    ThrowOnError extends boolean = false,
>(
    options: Options<DeleteApiCoaDraftCoaByCoaIdData, ThrowOnError>,
) => {
    return (options?.client ?? client).delete<
        ThrowOnError,
        DeleteApiCoaDraftCoaByCoaIdResponse,
        DeleteApiCoaDraftCoaByCoaIdError
    >({
        ...options,
        url: "/api/coa/draft-coa/{coa_id}",
    });
};

/**
 * Get Audit Logs By Coa Id
 */
export const getApiCoaAuditLogsByCoaId = <ThrowOnError extends boolean = false>(
    options: Options<GetApiCoaAuditLogsByCoaIdData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiCoaAuditLogsByCoaIdResponse,
        GetApiCoaAuditLogsByCoaIdError
    >({
        ...options,
        url: "/api/coa/audit-logs/{coa_id}",
    });
};

/**
 * Get Coa Definition By Coa Id
 */
export const getApiCoaCoaDefinitionByCoaId = <
    ThrowOnError extends boolean = false,
>(
    options: Options<GetApiCoaCoaDefinitionByCoaIdData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiCoaCoaDefinitionByCoaIdResponse,
        GetApiCoaCoaDefinitionByCoaIdError
    >({
        ...options,
        url: "/api/coa/coa-definition/{coa_id}",
    });
};

/**
 * Update Draft Coa Accounts
 */
export const postApiCoaDraftCoaAccountsByCoaId = <
    ThrowOnError extends boolean = false,
>(
    options: Options<PostApiCoaDraftCoaAccountsByCoaIdData, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiCoaDraftCoaAccountsByCoaIdResponse,
        PostApiCoaDraftCoaAccountsByCoaIdError
    >({
        ...options,
        url: "/api/coa/draft-coa-accounts/{coa_id}",
    });
};

/**
 * Complete Coa
 */
export const postApiCoaCompleteCoaByCoaId = <
    ThrowOnError extends boolean = false,
>(
    options: Options<PostApiCoaCompleteCoaByCoaIdData, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiCoaCompleteCoaByCoaIdResponse,
        PostApiCoaCompleteCoaByCoaIdError
    >({
        ...options,
        url: "/api/coa/complete-coa/{coa_id}",
    });
};

/**
 * Upload Coa File
 */
export const postApiCoaFiles = <ThrowOnError extends boolean = false>(
    options: Options<PostApiCoaFilesData, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiCoaFilesResponse,
        PostApiCoaFilesError
    >({
        ...options,
        ...formDataBodySerializer,
        headers: {
            "Content-Type": null,
        },
        url: "/api/coa/files",
    });
};

/**
 * Get Account Mapping Table Data
 */
export const getApiCoaMappingTableByCoaId = <
    ThrowOnError extends boolean = false,
>(
    options: Options<GetApiCoaMappingTableByCoaIdData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiCoaMappingTableByCoaIdResponse,
        GetApiCoaMappingTableByCoaIdError
    >({
        ...options,
        url: "/api/coa/mapping-table/{coa_id}",
    });
};

/**
 * Get Initial Config
 */
export const getApiInitialConfig = <ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiInitialConfigResponse,
        GetApiInitialConfigError
    >({
        ...options,
        url: "/api/initial-config",
    });
};

/**
 * Thirdparty Auth0 Config
 */
export const getApiThirdpartyAuth0Config = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<unknown, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiThirdpartyAuth0ConfigResponse,
        GetApiThirdpartyAuth0ConfigError
    >({
        ...options,
        url: "/api/thirdparty-auth0-config",
    });
};

/**
 * Get Project Groups
 */
export const getApiProjects = <ThrowOnError extends boolean = false>(
    options?: Options<GetApiProjectsData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiProjectsResponse,
        GetApiProjectsError
    >({
        ...options,
        url: "/api/projects/",
    });
};

/**
 * Create Project
 */
export const postApiProjects = <ThrowOnError extends boolean = false>(
    options: Options<PostApiProjectsData, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiProjectsResponse,
        PostApiProjectsError
    >({
        ...options,
        url: "/api/projects/",
    });
};

/**
 * List accessible projects with every attached property
 * Retrieve a list of projects accessible to the user given the company database IDs supplied in the `x-company-databases` header. Each project in the response includes every property attached to it (not just the first-registered headline property). Use this endpoint when you need to work with multi-property projects.
 */
export const getApiProjectsWithProperties = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<GetApiProjectsWithPropertiesData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiProjectsWithPropertiesResponse,
        GetApiProjectsWithPropertiesError
    >({
        ...options,
        url: "/api/projects/with-properties/",
    });
};

/**
 * Get Project Property
 */
export const getApiProjectsByProjectIdProperty = <
    ThrowOnError extends boolean = false,
>(
    options: Options<GetApiProjectsByProjectIdPropertyData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiProjectsByProjectIdPropertyResponse,
        GetApiProjectsByProjectIdPropertyError
    >({
        ...options,
        url: "/api/projects/{project_id}/property",
    });
};

/**
 * Get Rent Roll Location
 * Resolve an overview rent-roll row's workbook/worksheet identity.
 *
 * The bulk rentrolls feed backing the deal overview has no file/worksheet id,
 * so those rows can't build a view URL directly; the FE calls this on click.
 * Reuses the file-view resolution, which does carry the real identity.
 */
export const getApiProjectsByProjectIdRentRollLocation = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        GetApiProjectsByProjectIdRentRollLocationData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiProjectsByProjectIdRentRollLocationResponse,
        GetApiProjectsByProjectIdRentRollLocationError
    >({
        ...options,
        url: "/api/projects/{project_id}/rent-roll-location",
    });
};

/**
 * Check Property Name Exists
 */
export const postApiProjectsPropertyNameExists = <
    ThrowOnError extends boolean = false,
>(
    options: Options<PostApiProjectsPropertyNameExistsData, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiProjectsPropertyNameExistsResponse,
        PostApiProjectsPropertyNameExistsError
    >({
        ...options,
        url: "/api/projects/property-name-exists",
    });
};

/**
 * Check Property Exists
 */
export const postApiProjectsPropertyExists = <
    ThrowOnError extends boolean = false,
>(
    options: Options<PostApiProjectsPropertyExistsData, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiProjectsPropertyExistsResponse,
        PostApiProjectsPropertyExistsError
    >({
        ...options,
        url: "/api/projects/property-exists",
    });
};

/**
 * Check Project Name Exists
 */
export const postApiProjectsProjectNameExists = <
    ThrowOnError extends boolean = false,
>(
    options: Options<PostApiProjectsProjectNameExistsData, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiProjectsProjectNameExistsResponse,
        PostApiProjectsProjectNameExistsError
    >({
        ...options,
        url: "/api/projects/project-name-exists",
    });
};

/**
 * Upload File Unified
 */
export const postApiProjectsByProjectIdFilesUpload = <
    ThrowOnError extends boolean = false,
>(
    options: Options<PostApiProjectsByProjectIdFilesUploadData, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiProjectsByProjectIdFilesUploadResponse,
        PostApiProjectsByProjectIdFilesUploadError
    >({
        ...options,
        ...formDataBodySerializer,
        headers: {
            "Content-Type": null,
        },
        url: "/api/projects/{project_id}/files/upload",
    });
};

/**
 * Extract Rent Roll
 */
export const postApiProjectsByProjectIdFilesByFileIdExtractRentRoll = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        PostApiProjectsByProjectIdFilesByFileIdExtractRentRollData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiProjectsByProjectIdFilesByFileIdExtractRentRollResponse,
        PostApiProjectsByProjectIdFilesByFileIdExtractRentRollError
    >({
        ...options,
        url: "/api/projects/{project_id}/files/{file_id}/extract-rent-roll",
    });
};

/**
 * Get Project Files
 */
export const getApiProjectsByProjectIdFiles = <
    ThrowOnError extends boolean = false,
>(
    options: Options<GetApiProjectsByProjectIdFilesData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiProjectsByProjectIdFilesResponse,
        GetApiProjectsByProjectIdFilesError
    >({
        ...options,
        url: "/api/projects/{project_id}/files",
    });
};

/**
 * Soft Delete Files
 */
export const deleteApiProjectsByProjectIdFiles = <
    ThrowOnError extends boolean = false,
>(
    options: Options<DeleteApiProjectsByProjectIdFilesData, ThrowOnError>,
) => {
    return (options?.client ?? client).delete<
        ThrowOnError,
        DeleteApiProjectsByProjectIdFilesResponse,
        DeleteApiProjectsByProjectIdFilesError
    >({
        ...options,
        url: "/api/projects/{project_id}/files",
    });
};

/**
 * Soft Delete Project
 */
export const deleteApiProjectsByProjectId = <
    ThrowOnError extends boolean = false,
>(
    options: Options<DeleteApiProjectsByProjectIdData, ThrowOnError>,
) => {
    return (options?.client ?? client).delete<
        ThrowOnError,
        DeleteApiProjectsByProjectIdResponse,
        DeleteApiProjectsByProjectIdError
    >({
        ...options,
        url: "/api/projects/{project_id}",
    });
};

/**
 * Get Project
 */
export const getApiProjectsByProjectId = <ThrowOnError extends boolean = false>(
    options: Options<GetApiProjectsByProjectIdData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiProjectsByProjectIdResponse,
        GetApiProjectsByProjectIdError
    >({
        ...options,
        url: "/api/projects/{project_id}",
    });
};

/**
 * Get Operating Statement Period
 */
export const getApiProjectsByProjectIdByAnnualizationTypeOperatingStatementPeriods =
    <ThrowOnError extends boolean = false>(
        options: Options<
            GetApiProjectsByProjectIdByAnnualizationTypeOperatingStatementPeriodsData,
            ThrowOnError
        >,
    ) => {
        return (options?.client ?? client).get<
            ThrowOnError,
            GetApiProjectsByProjectIdByAnnualizationTypeOperatingStatementPeriodsResponse,
            GetApiProjectsByProjectIdByAnnualizationTypeOperatingStatementPeriodsError
        >({
            ...options,
            url: "/api/projects/{project_id}/{annualization_type}/operating-statement/periods",
        });
    };

/**
 * Get Operating Statement
 */
export const getApiProjectsByProjectIdOperatingStatement = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        GetApiProjectsByProjectIdOperatingStatementData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiProjectsByProjectIdOperatingStatementResponse,
        GetApiProjectsByProjectIdOperatingStatementError
    >({
        ...options,
        url: "/api/projects/{project_id}/operating-statement",
    });
};

/**
 * Check Overlapping Period In Deal
 */
export const getApiProjectsByProjectIdExtractionByExtractionIdOverlappingPeriods =
    <ThrowOnError extends boolean = false>(
        options: Options<
            GetApiProjectsByProjectIdExtractionByExtractionIdOverlappingPeriodsData,
            ThrowOnError
        >,
    ) => {
        return (options?.client ?? client).get<
            ThrowOnError,
            GetApiProjectsByProjectIdExtractionByExtractionIdOverlappingPeriodsResponse,
            GetApiProjectsByProjectIdExtractionByExtractionIdOverlappingPeriodsError
        >({
            ...options,
            url: "/api/projects/{project_id}/extraction/{extraction_id}/overlapping-periods",
        });
    };

/**
 * Get Conflicted Extractions
 */
export const getApiProjectsByProjectIdExtractionByExtractionIdConflictedExtractions =
    <ThrowOnError extends boolean = false>(
        options: Options<
            GetApiProjectsByProjectIdExtractionByExtractionIdConflictedExtractionsData,
            ThrowOnError
        >,
    ) => {
        return (options?.client ?? client).get<
            ThrowOnError,
            GetApiProjectsByProjectIdExtractionByExtractionIdConflictedExtractionsResponse,
            GetApiProjectsByProjectIdExtractionByExtractionIdConflictedExtractionsError
        >({
            ...options,
            url: "/api/projects/{project_id}/extraction/{extraction_id}/conflicted-extractions",
        });
    };

/**
 * Convert Extractions To Draft
 */
export const postApiProjectsByProjectIdExtractionByExtractionIdConvertToDraft =
    <ThrowOnError extends boolean = false>(
        options: Options<
            PostApiProjectsByProjectIdExtractionByExtractionIdConvertToDraftData,
            ThrowOnError
        >,
    ) => {
        return (options?.client ?? client).post<
            ThrowOnError,
            PostApiProjectsByProjectIdExtractionByExtractionIdConvertToDraftResponse,
            PostApiProjectsByProjectIdExtractionByExtractionIdConvertToDraftError
        >({
            ...options,
            url: "/api/projects/{project_id}/extraction/{extraction_id}/convert-to-draft",
        });
    };

/**
 * Download Annualization
 */
export const getApiProjectsByProjectIdOperatingStatementExport = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        GetApiProjectsByProjectIdOperatingStatementExportData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiProjectsByProjectIdOperatingStatementExportResponse,
        GetApiProjectsByProjectIdOperatingStatementExportError
    >({
        ...options,
        url: "/api/projects/{project_id}/operating-statement/export",
    });
};

/**
 * Update Project
 */
export const putApiProjectsUpdate = <ThrowOnError extends boolean = false>(
    options: Options<PutApiProjectsUpdateData, ThrowOnError>,
) => {
    return (options?.client ?? client).put<
        ThrowOnError,
        PutApiProjectsUpdateResponse,
        PutApiProjectsUpdateError
    >({
        ...options,
        url: "/api/projects/update",
    });
};

/**
 * Create Property
 */
export const postApiProjectsPropertyCreate = <
    ThrowOnError extends boolean = false,
>(
    options: Options<PostApiProjectsPropertyCreateData, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiProjectsPropertyCreateResponse,
        PostApiProjectsPropertyCreateError
    >({
        ...options,
        url: "/api/projects/property/create",
    });
};

/**
 * Update Property
 */
export const putApiProjectsPropertyUpdate = <
    ThrowOnError extends boolean = false,
>(
    options: Options<PutApiProjectsPropertyUpdateData, ThrowOnError>,
) => {
    return (options?.client ?? client).put<
        ThrowOnError,
        PutApiProjectsPropertyUpdateResponse,
        PutApiProjectsPropertyUpdateError
    >({
        ...options,
        url: "/api/projects/property/update",
    });
};

/**
 * Get Project By Deal Id
 * This endpoint is used for redirection of the legacy deal routes on the front-end.
 * This allows e.g. existing bookmarks to still function.
 */
export const getApiProjectsByDealByDealId = <
    ThrowOnError extends boolean = false,
>(
    options: Options<GetApiProjectsByDealByDealIdData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiProjectsByDealByDealIdResponse,
        GetApiProjectsByDealByDealIdError
    >({
        ...options,
        url: "/api/projects/by-deal/{deal_id}",
    });
};

/**
 * Project Delete Property
 */
export const deleteApiProjectsPropertyByPropertyId = <
    ThrowOnError extends boolean = false,
>(
    options: Options<DeleteApiProjectsPropertyByPropertyIdData, ThrowOnError>,
) => {
    return (options?.client ?? client).delete<
        ThrowOnError,
        DeleteApiProjectsPropertyByPropertyIdResponse,
        DeleteApiProjectsPropertyByPropertyIdError
    >({
        ...options,
        url: "/api/projects/property/{property_id}",
    });
};

/**
 * Get Property Info For Delete
 */
export const getApiProjectsPropertyInfoForDeleteByPropertyId = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        GetApiProjectsPropertyInfoForDeleteByPropertyIdData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiProjectsPropertyInfoForDeleteByPropertyIdResponse,
        GetApiProjectsPropertyInfoForDeleteByPropertyIdError
    >({
        ...options,
        url: "/api/projects/property/info-for-delete/{property_id}",
    });
};

/**
 * Get Google Maps Config
 */
export const getApiGoogleMapsConfig = <ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiGoogleMapsConfigResponse,
        GetApiGoogleMapsConfigError
    >({
        ...options,
        url: "/api/google-maps-config",
    });
};

/**
 * Trigger Database Sync
 */
export const postApiDatabasesScheduledDatabaseSync = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<unknown, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiDatabasesScheduledDatabaseSyncResponse,
        PostApiDatabasesScheduledDatabaseSyncError
    >({
        ...options,
        url: "/api/databases/scheduled-database-sync",
    });
};

/**
 * Manual Database Sync
 */
export const postApiDatabasesManualDatabaseSync = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<unknown, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiDatabasesManualDatabaseSyncResponse,
        PostApiDatabasesManualDatabaseSyncError
    >({
        ...options,
        url: "/api/databases/manual-database-sync",
    });
};

/**
 * Get Coa List
 */
export const getApiDatabasesByDatabaseIdCoaDefinitions = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        GetApiDatabasesByDatabaseIdCoaDefinitionsData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiDatabasesByDatabaseIdCoaDefinitionsResponse,
        GetApiDatabasesByDatabaseIdCoaDefinitionsError
    >({
        ...options,
        url: "/api/databases/{database_id}/coa-definitions",
    });
};

/**
 * Admin Get All Coa Definitions
 */
export const postApiDatabasesAdminCoaDefinitions = <
    ThrowOnError extends boolean = false,
>(
    options: Options<PostApiDatabasesAdminCoaDefinitionsData, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiDatabasesAdminCoaDefinitionsResponse,
        PostApiDatabasesAdminCoaDefinitionsError
    >({
        ...options,
        url: "/api/databases/admin/coa-definitions",
    });
};

/**
 * Admin Get All Databases
 */
export const getApiDatabasesAdminAll = <ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiDatabasesAdminAllResponse,
        GetApiDatabasesAdminAllError
    >({
        ...options,
        url: "/api/databases/admin/all",
    });
};

/**
 * Admin Get Companies
 */
export const getApiDatabasesAdminCompanies = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<unknown, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetApiDatabasesAdminCompaniesResponse,
        GetApiDatabasesAdminCompaniesError
    >({
        ...options,
        url: "/api/databases/admin/companies",
    });
};

/**
 * Get Databases Metadata
 */
export const postApiDatabasesMeta = <ThrowOnError extends boolean = false>(
    options: Options<PostApiDatabasesMetaData, ThrowOnError>,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiDatabasesMetaResponse,
        PostApiDatabasesMetaError
    >({
        ...options,
        url: "/api/databases/meta",
    });
};

/**
 * Create Company Database
 */
export const postApiDatabasesCompaniesByCompanyIdDatabases = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        PostApiDatabasesCompaniesByCompanyIdDatabasesData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiDatabasesCompaniesByCompanyIdDatabasesResponse,
        PostApiDatabasesCompaniesByCompanyIdDatabasesError
    >({
        ...options,
        url: "/api/databases/companies/{company_id}/databases",
    });
};

/**
 * Delete Company Database
 */
export const deleteApiDatabasesCompaniesByCompanyIdDatabasesByDatabaseId = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        DeleteApiDatabasesCompaniesByCompanyIdDatabasesByDatabaseIdData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).delete<
        ThrowOnError,
        DeleteApiDatabasesCompaniesByCompanyIdDatabasesByDatabaseIdResponse,
        DeleteApiDatabasesCompaniesByCompanyIdDatabasesByDatabaseIdError
    >({
        ...options,
        url: "/api/databases/companies/{company_id}/databases/{database_id}",
    });
};

/**
 * Admin Cleanup E2E Databases
 */
export const postApiDatabasesAdminCleanupE2eDatabases = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<
        PostApiDatabasesAdminCleanupE2eDatabasesData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).post<
        ThrowOnError,
        PostApiDatabasesAdminCleanupE2eDatabasesResponse,
        PostApiDatabasesAdminCleanupE2eDatabasesError
    >({
        ...options,
        url: "/api/databases/admin/cleanup-e2e-databases",
    });
};

/**
 * Get Databases
 * Retrieve a list of databases accessible to the user.
 */
export const getThirdpartyV1Databases = <ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetThirdpartyV1DatabasesResponse,
        GetThirdpartyV1DatabasesError
    >({
        ...options,
        url: "/thirdparty/v1/databases/",
    });
};

/**
 * @deprecated
 * List all accessible deals
 * Retrieve a comprehensive list of all deals that the authenticated user has access to within the specified company databases. This endpoint filters deals based on user permissions and the provided database identifiers in the header. This endpoint is deprecated in favor of '/thirdparty/v1/projects/'.
 */
export const getThirdpartyV1Deals = <ThrowOnError extends boolean = false>(
    options: Options<GetThirdpartyV1DealsData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetThirdpartyV1DealsResponse,
        GetThirdpartyV1DealsError
    >({
        ...options,
        url: "/thirdparty/v1/deals/",
    });
};

/**
 * @deprecated
 * Get operating statement data by deal ID
 * Legacy endpoint to retrieve operating statement financial data for a specific deal. This endpoint is deprecated in favor of the '/id/{deal_id}/operating-statement' endpoint which provides the same functionality with improved path structure.
 */
export const getThirdpartyV1DealsByDealIdOperatingStatement = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        GetThirdpartyV1DealsByDealIdOperatingStatementData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetThirdpartyV1DealsByDealIdOperatingStatementResponse,
        GetThirdpartyV1DealsByDealIdOperatingStatementError
    >({
        ...options,
        url: "/thirdparty/v1/deals/{deal_id}/operating-statement",
    });
};

/**
 * @deprecated
 * Get operating statement data by deal ID
 * Retrieve detailed operating statement financial data for a specific deal using its unique identifier. Supports flexible date ranges, multiple aggregation intervals (monthly, quarterly, half-yearly, yearly), and both aggregated and detailed view modes. Returns comprehensive financial metrics including revenue, expenses, and net operating income. This endpoint is deprecated in favor of '/thirdparty/v1/projects/{project_id}/operating-statement'.
 */
export const getThirdpartyV1DealsIdByDealIdOperatingStatement = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        GetThirdpartyV1DealsIdByDealIdOperatingStatementData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetThirdpartyV1DealsIdByDealIdOperatingStatementResponse,
        GetThirdpartyV1DealsIdByDealIdOperatingStatementError
    >({
        ...options,
        url: "/thirdparty/v1/deals/id/{deal_id}/operating-statement",
    });
};

/**
 * @deprecated
 * Get available reporting periods for a deal
 * Retrieve all available reporting periods (months/quarters) for which operating statement data exists for the specified deal. This endpoint is useful for understanding the temporal scope of available financial data before querying specific operating statements. This endpoint is deprecated in favor of '/thirdparty/v1/projects/{project_id}/periods'.
 */
export const getThirdpartyV1DealsByDealIdPeriods = <
    ThrowOnError extends boolean = false,
>(
    options: Options<GetThirdpartyV1DealsByDealIdPeriodsData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetThirdpartyV1DealsByDealIdPeriodsResponse,
        GetThirdpartyV1DealsByDealIdPeriodsError
    >({
        ...options,
        url: "/thirdparty/v1/deals/{deal_id}/periods",
    });
};

/**
 * @deprecated
 * Get operating statement data by deal name
 * Retrieve detailed operating statement financial data for a deal using its name instead of ID. Performs case-insensitive name matching to locate the deal, then returns the same comprehensive financial data as the ID-based endpoint. Supports flexible date ranges, multiple aggregation intervals, and both aggregated and detailed view modes. This endpoint is deprecated in favor of '/thirdparty/v1/projects/name/{project_name}/operating-statement'.
 */
export const getThirdpartyV1DealsNameByDealNameOperatingStatement = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        GetThirdpartyV1DealsNameByDealNameOperatingStatementData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetThirdpartyV1DealsNameByDealNameOperatingStatementResponse,
        GetThirdpartyV1DealsNameByDealNameOperatingStatementError
    >({
        ...options,
        url: "/thirdparty/v1/deals/name/{deal_name}/operating-statement",
    });
};

/**
 * Get Project List
 * Retrieve a list of projects accessible to the user given company database id.
 */
export const getThirdpartyV1Projects = <ThrowOnError extends boolean = false>(
    options: Options<GetThirdpartyV1ProjectsData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetThirdpartyV1ProjectsResponse,
        GetThirdpartyV1ProjectsError
    >({
        ...options,
        url: "/thirdparty/v1/projects/",
    });
};

/**
 * Get Project Operating Statement
 */
export const getThirdpartyV1ProjectsByProjectIdOperatingStatement = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        GetThirdpartyV1ProjectsByProjectIdOperatingStatementData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetThirdpartyV1ProjectsByProjectIdOperatingStatementResponse,
        GetThirdpartyV1ProjectsByProjectIdOperatingStatementError
    >({
        ...options,
        url: "/thirdparty/v1/projects/{project_id}/operating-statement",
    });
};

/**
 * Get operating statement data by project name
 * Retrieve detailed operating statement financial data for a project using its name instead of ID. Performs case-insensitive name matching to locate the project, then returns the same comprehensive financial data as the ID-based endpoint. Supports flexible date ranges, multiple aggregation intervals, and both aggregated and detailed view modes.
 */
export const getThirdpartyV1ProjectsNameByProjectNameOperatingStatement = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        GetThirdpartyV1ProjectsNameByProjectNameOperatingStatementData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetThirdpartyV1ProjectsNameByProjectNameOperatingStatementResponse,
        GetThirdpartyV1ProjectsNameByProjectNameOperatingStatementError
    >({
        ...options,
        url: "/thirdparty/v1/projects/name/{project_name}/operating-statement",
    });
};

/**
 * Fetch Project Periods
 */
export const getThirdpartyV1ProjectsByProjectIdPeriods = <
    ThrowOnError extends boolean = false,
>(
    options: Options<
        GetThirdpartyV1ProjectsByProjectIdPeriodsData,
        ThrowOnError
    >,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetThirdpartyV1ProjectsByProjectIdPeriodsResponse,
        GetThirdpartyV1ProjectsByProjectIdPeriodsError
    >({
        ...options,
        url: "/thirdparty/v1/projects/{project_id}/periods",
    });
};

/**
 * [Unstable] List all accessible chart of accounts
 * Retrieve a list of all Chart of Accounts definitions that the authenticated user has access to. Optionally filter by company databases using the x-company-databases header.
 *
 * **Note:** This endpoint is subject to change and is only available in non-production environments.
 */
export const getThirdpartyV1ChartOfAccounts = <
    ThrowOnError extends boolean = false,
>(
    options?: Options<GetThirdpartyV1ChartOfAccountsData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetThirdpartyV1ChartOfAccountsResponse,
        GetThirdpartyV1ChartOfAccountsError
    >({
        ...options,
        url: "/thirdparty/v1/chart-of-accounts/",
    });
};

/**
 * [Unstable] Get chart of accounts details
 * Retrieve the definition and account details for a specific Chart of Accounts by its ID. The user must have access to the COA via their database permissions.
 *
 * **Note:** This endpoint is subject to change and is only available in non-production environments.
 */
export const getThirdpartyV1ChartOfAccountsByCoaId = <
    ThrowOnError extends boolean = false,
>(
    options: Options<GetThirdpartyV1ChartOfAccountsByCoaIdData, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetThirdpartyV1ChartOfAccountsByCoaIdResponse,
        GetThirdpartyV1ChartOfAccountsByCoaIdError
    >({
        ...options,
        url: "/thirdparty/v1/chart-of-accounts/{coa_id}",
    });
};

/**
 * Healthcheck
 */
export const getHealthcheck = <ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>,
) => {
    return (options?.client ?? client).get<
        ThrowOnError,
        GetHealthcheckResponse,
        GetHealthcheckError
    >({
        ...options,
        url: "/healthcheck",
    });
};
